export default "__VITE_ASSET__0502a9c6__"